import React from 'react'
import { FormattedMessage } from 'react-intl'

import { PackageAlert } from '../ShippingPackage/PackageAlert'

type NoShippingMethodAvailableAlertProps = {
  postalCode: string | undefined
  itemName: string | undefined
}

export const NoShippingMethodAvailableAlert = ({
  postalCode,
  itemName,
}: NoShippingMethodAvailableAlertProps) => (
  <PackageAlert>
    <FormattedMessage
      id="checkout.no-shipping-method"
      values={{ postalCode, itemName }}
    />
  </PackageAlert>
)
